import parseISO from 'date-fns/parseISO';

const KEY_SPARKOL_TOKEN = 'token';
const KEY_UID = 'uid';
const KEY_USER_INFO = 'user_info';

export function setSparkolCookies({ token, user }) {
  window.electron.store.set(KEY_SPARKOL_TOKEN, token);
  window.electron.store.set(KEY_UID, user.id.toString());
  window.electron.store.set(KEY_USER_INFO, { ...user, id: user.id.toString() });
}

export function getUID() {
  return window.electron.store.get(KEY_UID);
}

export function getSparkolToken() {
  return window.electron.store.get(KEY_SPARKOL_TOKEN);
}

export async function getUserInfo() {
  try {
    const userInfo = window.electron.store.get(KEY_USER_INFO);
    if (userInfo) {
      const parsed = userInfo;
      parsed.trialExpiryDate = parseISO(parsed.trialExpiryDate);
      return parsed;
    } else {
      throw new Error('No user info stored in cookies');
    }
  } catch (error) {
    throw new Error('Failed to get user info from cookies', error.message);
  }
}

export function removeSparkolCookies() {
  localStorage.removeItem('id_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');

  window.electron.store.reset();
}

export async function getRendererAuth() {
  const allCoolies = await window.electron.getAllCookies();
  return {
    rendererAuth: allCoolies.filter(cookie => cookie.name === 'rendererAuth')[0]?.value,
    rendererUser: allCoolies.filter(cookie => cookie.name === 'rendererUser')[0]?.value
  };
}
